import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUiTranslation } from "../../../i18n";
import { Label, Select, SelectTrigger, SelectValue, SelectItem, } from "../../../components/base";
import { InteractionRequestSelectContent } from "./InteractionRequestSelectContent";
import { FieldDescription } from "../FieldDescription";
export const DropdownField = ({ field, value, disabled, error, onChange, }) => {
    const { t } = useUiTranslation();
    const options = field.options ?? [];
    return (_jsxs("div", { className: "space-y-1", children: [_jsxs(Label, { className: "text-xs", children: [field.question, " ", field.required && _jsx("span", { className: "text-red-500", children: "*" })] }), _jsx(FieldDescription, { ...field }), _jsxs(Select, { value: value ?? "", onValueChange: onChange, disabled: disabled, children: [_jsx(SelectTrigger, { className: error ? "border-red-500 focus:ring-red-500" : undefined, children: _jsx(SelectValue, { placeholder: field.placeholder || t("form.selectPlaceholder") }) }), _jsx(InteractionRequestSelectContent, { children: options.map((opt) => (_jsx(SelectItem, { value: opt.value, children: opt.label }, opt.value))) })] }), error && _jsx("p", { className: "text-xs text-red-500", children: error })] }));
};
export const validateDropdownField = (field, value, t) => {
    if (!field.required)
        return undefined;
    const str = value === undefined || value === null ? "" : String(value);
    if (str.trim() === "") {
        return t("form.validation.required");
    }
    return undefined;
};
export const serializeDropdownField = (field, value) => {
    const options = Array.isArray(field.options) ? field.options : [];
    const found = options.find((o) => o.value === value);
    return found ? found.label : value;
};
//# sourceMappingURL=DropdownField.js.map